module.exports = __webpack_public_path__ + "img/washington_monument.27c67ef9.jpg";